import ModalSubscription from "../ui/components/ModalSubscription";
import EmailValidation from "../ui/components/SignUpInformation/components/EmailValidation";
import Signup from "../ui/pages/Signup";
import createLink from "./createLink";
import Warning from "../ui/components/warnings/Warning";



const fnClickCta = (data = {}) => {
    let {role = "", gender = 0, isBan = null, forbidden = {}} = data;
    let infos = {
        modal: null,
        to: createLink("userMeSettingsAbonnement")
    };

    let infosUpload = {...infos};

    // console.log(role);
    switch(role){
        case"emailUnconfirmed":
            return {
                like : {
                    modal : EmailValidation
                },
                addFriend : {
                    modal : EmailValidation
                },
                addFollow : {
                    modal : EmailValidation
                },
                createAlbum : {
                    modal : EmailValidation
                },
                createTopic : {
                    modal : EmailValidation
                },
                createArticle : {
                    modal : EmailValidation
                },
                createComment : {
                    modal : EmailValidation
                },
                createStatus : {
                    modal : EmailValidation
                },
                rooms : {
                    modal : EmailValidation
                },
                upload : {
                    modal : EmailValidation
                },
                chatWebcam : {
                    modal : EmailValidation
                },
                meetSearch : {
                    modal : EmailValidation
                },
            };
        case"standard":
            if(isBan){
                infos = {
                    modal: Warning,
                    to: createLink("userMe")
                }
            }
            else if(![2,3,4].includes(gender)){
                infos = {
                    modal: ModalSubscription,
                    to: createLink("userMeSettingsAbonnement")
                }
            }
            infosUpload = {...infos};

            if(forbidden.createMedia){
                infosUpload = {
                    modal: Warning,
                    to: createLink("userMe")
                }
            }

            return {
                like : infos,
                addFriend : infos,
                addFollow : infos,
                createAlbum : infos,
                createTopic : infos,
                createArticle : infos,
                createComment : infos,
                createStatus : infos,
                rooms : infos,
                upload : infosUpload,
                chatWebcam : infos
            };
        case"creator":
            if(isBan){
                infos = {
                    modal: Warning,
                    to: createLink("userMe")
                }
            }
            else if([2,3,4].includes(gender)){
                infos = {
                    modal: ModalSubscription,
                    to: createLink("userMeSettingsAbonnement")
                }
            }

            infosUpload = {...infos};

            if(forbidden.createMedia){
                infosUpload = {
                    modal: Warning,
                    to: createLink("userMe")
                }
            }

            return {
                like : infos,
                addFriend : infos,
                addFollow : infos,
                createAlbum : infos,
                createTopic : infos,
                createArticle : infos,
                createComment : infos,
                createStatus : infos,
                rooms : infos,
                upload : infosUpload,
                chatWebcam : infos
            };

        case"banned":
            return {};
        default :
            return {
                like : {
                    modal : Signup,
                    to : createLink("signin")
                },
                addFriend : {
                    modal : Signup,
                    to : createLink("signin")
                },
                addFollow : {
                    modal : Signup,
                    to : createLink("signin")
                },
                createAlbum : {
                    modal : Signup,
                    to : createLink("signin")
                },
                createTopic : {
                    modal : Signup,
                    to : createLink("signin")
                },
                createArticle : {
                    to : createLink("signin")
                },
                createComment : {
                    to : createLink("signin")
                },
                createStatus : {
                    modal : Signup,
                    to : createLink("signin")
                },
                rooms : {
                    to : createLink("signin")
                },
                upload : {
                    modal : Signup,
                    to : createLink("signin")
                },
                chatWebcam : {
                    modal : Signup,
                    to : createLink("signin")
                },
                meetSearch : {
                    modal : Signup,
                    to : createLink("signin")
                }
            };
    }
};


// createLink("charter");
export default fnClickCta;
